module.exports = __webpack_public_path__ + "img/head.ebc37cd5.png";